export default __webpack_public_path__ + "static/media/403-error.6eec24fd.svg";